exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "@media (max-width:540px){table.v-table td,table.v-table th{padding:0 5px!important}}", "", {"version":3,"sources":["C:/workspace/steemit-app/src/components/VoteHistory.vue"],"names":[],"mappings":"AACA,yBACA,kCACI,uBAA0B,CAC7B,CACA","file":"VoteHistory.vue","sourcesContent":["\n@media (max-width: 540px) {\ntable.v-table td, table.v-table th {\r\n    padding: 0 5px !important;\n}\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-87e3448c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/VoteHistory.vue
// module id = 691
// module chunks = 5